import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REGISTER } from "../../../config/api";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { storeAccessToken } from "../../../helper/manageAccessToken";

export const registerUsers = createAsyncThunk(
  "users/register",
  async ({ data, navigate, setSubmitting }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_REGISTER,
        data,
      });
      const accessToken = response?.data?.data?.access_token;
      const user = response?.data?.data?.user;

      storeAccessToken(accessToken);

      navigate("/otp", {
        state: { email: user?.email },
      });
      mixpanel.track("WEB-Signed Up", { type: "SignUp" });
      mixpanel.identify(user?.email);
      mixpanel.register({ email: user?.email });
      mixpanel.people.set({
        // $first_name: response.data?.user?.name,
        // $last_name: response.data?.user?.fullName?.split(" ")[1],
        $name: user?.name,
        $email: user?.email,
        $created: new Date(),
      });

      mixpanel.people.set({ "First Login Date": new Date() });

      return user;
    } catch (error) {
      setSubmitting(false);
      const message = proccessErrorMessage(error);
      toast.error(message || "Error, please try again");

      mixpanel.track("WEB-SignUp Failed", {
        type: "SignUp",

        message: message,
      });

      throw error;
    }
  }
);
